<template>
  <div class="max-w-screen-xl mx-auto mt-4 mb-10">
    <div class="bg-white">
      <div class="max-w-2xl mx-auto lg:max-w-7xl py-4">
        <div class="border-b border-gray-200 flex font-light">
          <nav class="-mb-px flex-grow flex" aria-label="Tabs">
            <template v-if="false">
              <span
                class="border-transparent text-gray-500 group inline-flex items-center py-0 px-2 mr-8 border-b-2 text-xs hidden lg:flex"
                >{{ $t("searchResult.header.sort.title") }}</span
              >

              <a
                @click="
                  setSortBy(
                    sortByType === 'priceASC' ? 'priceDESC' : 'priceASC'
                  )
                "
                class="cursor-pointer hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-0 px-2 mr-8 border-b-2 text-xs"
                :class="{
                  'border-brand-main text-brand-main':
                    sortByType === 'priceASC' || sortByType === 'priceDESC',
                  'border-transparent text-gray-300':
                    sortByType !== 'priceASC' && sortByType !== 'priceDESC',
                }"
              >
                <!-- Heroicon name: solid/office-building -->
                <svg
                  class="group-hover:text-gray-500 -ml-0.5 mr-2 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    v-if="sortByType === 'priceDESC'"
                    fill-rule="evenodd"
                    d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                  <path
                    v-else
                    fill-rule="evenodd"
                    d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>{{ $t("searchResult.header.sort.price") }}</span>
              </a>

              <a
                @click="
                  setSortBy(
                    sortByType === 'caratASC' ? 'caratDESC' : 'caratASC'
                  )
                "
                class="cursor-pointer hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 text-sm"
                :class="{
                  'border-brand-main text-brand-main':
                    sortByType === 'caratASC' || sortByType === 'caratDESC',
                  'border-transparent text-gray-300':
                    sortByType !== 'caratASC' && sortByType !== 'caratDESC',
                }"
              >
                <svg
                  class="-ml-0.5 mr-2 h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    v-if="sortByType === 'caratDESC'"
                    fill-rule="evenodd"
                    d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                  <path
                    v-else
                    fill-rule="evenodd"
                    d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>{{ $t("searchResult.header.sort.size") }}</span>
              </a>
            </template>
          </nav>
          <div class="-mb-px text-gray-500 space-x-4 flex">
            <a
              @click="toggleFastDelivery(!fastDelivery)"
              class="cursor-pointer hover:text-gray-700 hover:border-gray-300 group inline-flex items-center text-sm"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-brand-main mr-2"
                fill="currentColor"
                viewBox="0 0 1024 1024"
                stroke="currentColor"
              >
                <path
                  d="M782.718293 970.970453c71.765333-1.133227 130.276693-56.388267 135.594667-126.788266H1020.586667v-360.413867L898.034347 284.740267c-27.19744-45.581653-77.325653-74.028373-130.802347-74.15808h-146.432c0.641707-85.500587-68.703573-156.112213-155.047253-157.55264H158.53568a157.873493 157.873493 0 0 0-110.721707 47.981226 155.490987 155.490987 0 0 0-44.373333 111.40096v505.777494c-0.498347 59.880107 41.168213 111.858347 99.71712 124.39552a133.768533 133.768533 0 0 0 40.874667 87.978666 135.85408 135.85408 0 0 0 94.16704 38.27712h0.682666c71.31136 0 129.846613-54.039893 135.512747-123.97568h177.762987a29.6448 29.6448 0 0 0 11.96032 2.49856h81.05984c0.692907 0 1.3824-0.054613 2.06848-0.1536 6.710613 68.836693 64.969387 122.661547 135.30112 123.757227l0.170666 0.003413zM239.31904 762.743467h1.62816c39.338667 0.863573 71.000747 33.338027 70.567253 72.37632-0.43008 39.041707-32.771413 70.81984-72.123733 70.843733a73.19552 73.19552 0 0 1-51.52768-22.21056c-27.654827-27.784533-27.55584-72.72448 0.218453-100.37248a70.997333 70.997333 0 0 1 51.213654-20.67456l0.023893 0.037547z m543.197867-5.1712c40.884907 1.024 72.88832 33.590613 72.88832 74.164906 0 40.57088-32.02048 73.1648-72.895147 74.15808a73.745067 73.745067 0 0 1-51.58912-22.05696 72.635733 72.635733 0 0 1-20.59264-51.94752v-0.21504a72.103253 72.103253 0 0 1 20.657493-51.923626 73.22624 73.22624 0 0 1 51.541334-22.19008l-0.01024 0.01024z m0.095573-65.621334a137.045333 137.045333 0 0 0-128.075093 90.733227 30.306987 30.306987 0 0 0-9.782614-1.631573h-24.132266V276.21376h146.599253a89.695573 89.695573 0 0 1 76.776107 43.776l112.32256 183.217493v276.616534h-47.39072c-19.913387-51.739307-70.11328-86.893227-126.163627-87.886507h-0.170667l0.017067 0.013653z m-416.764587 87.872854a134.46144 134.46144 0 0 0-125.801813-87.872854h-0.70656a134.63552 134.63552 0 0 0-125.68576 85.654187A61.5936 61.5936 0 0 1 67.8912 717.6192v-5.573973h-0.238933v-499.712c-0.914773-50.756267 39.888213-92.801707 90.90048-93.801814h307.03616c51.0464 1.017173 91.83232 43.055787 90.903893 93.713067v567.586133l-190.644907-0.006826z m490.52672-257.44384c18.312533-0.69632 32.59392-16.104107 31.901014-34.41664a33.184427 33.184427 0 0 0-31.901014-31.894187h-100.276906v-103.703893a31.668907 31.668907 0 0 0-9.038507-23.087787 32.201387 32.201387 0 0 0-22.725973-9.570987h-0.36864c-17.95072 0.126293-32.50176 14.578347-32.774827 32.518827v170.14784l165.184853 0.006827z"
                />
              </svg>
              <span
                class="border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-2 mr-2 border-b-2 text-sm hidden lg:flex"
                >{{ $t("searchResult.header.fastDelivery") }}</span
              >
              <input
                type="checkbox"
                :checked="fastDelivery"
                class="focus:ring-brand-main h-4 w-4 text-brand-main border-brand-main rounded"
              />
            </a>
          </div>
          <div class="-mb-px text-gray-500 flex space-x-4 hidden md:flex">
            <span
              class="border-transparent text-gray-500 group inline-flex items-center py-2 px-1 pl-10 border-b-2 text-sm"
              >{{ $t("searchResult.header.view.title") }}</span
            >
            <a
              @click="viewType = 'table'"
              class="cursor-pointer hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
              :title="$t('searchResult.header.view.table')"
              :class="{
                'border-brand-main text-brand-main':
                  viewType === 'table' || viewType === 'table',
                'border-transparent text-gray-300':
                  viewType !== 'table' && viewType !== 'table',
              }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 10h16M4 14h16M4 18h16"
                />
              </svg>
            </a>
            <a
              @click="viewType = 'gallery'"
              class="cursor-pointer hover:text-gray-700 hover:border-gray-300 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm"
              :title="$t('searchResult.header.view.gallery')"
              :class="{
                'border-brand-main text-brand-main':
                  viewType === 'gallery' || viewType === 'gallery',
                'border-transparent text-gray-300':
                  viewType !== 'gallery' && viewType !== 'gallery',
              }"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="mx-auto">
        <h2 class="sr-only">{{ $t("searchResult.header.diamonds") }}</h2>

        <section v-if="pageResult.length !== 0">
          <div
            v-if="viewType === 'gallery'"
            class="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-6 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-8 xl:grid-cols-4"
          >
            <SearchResultDiamond
              v-for="diamond in pageResult"
              :key="'diamond' + diamond.certificate"
              :diamond="diamond"
              :conf-session="confSession"
            />
          </div>
          <div
            v-else-if="viewType === 'table'"
            class="grid grid-cols-1 divide-y"
          >
            <table class="w-full text-center">
              <thead
                class="bg-brand-bg text-brand-text tracking-widest text-xs"
              >
                <tr>
                  <td class="py-3">
                    {{ $t("searchResult.table.head.image") }}
                  </td>
                  <td>{{ $t("searchResult.table.head.form") }}</td>
                  <td>{{ $t("searchResult.table.head.size") }}</td>
                  <td>{{ $t("searchResult.table.head.color") }}</td>
                  <td>{{ $t("searchResult.table.head.clarity") }}</td>
                  <td>{{ $t("searchResult.table.head.cut") }}</td>
                  <td>{{ $t("searchResult.table.head.polish") }}</td>
                  <td>{{ $t("searchResult.table.head.symmetry") }}</td>
                  <td>{{ $t("searchResult.table.head.fluorescence") }}</td>
                  <td>{{ $t("searchResult.table.head.institute") }}</td>
                  <td>{{ $t("searchResult.table.head.price") }}</td>
                  <td>{{ $t("searchResult.table.head.details") }}</td>
                </tr>
              </thead>
              <tfoot
                class="bg-brand-bg text-brand-text tracking-widest text-xs"
              >
                <tr>
                  <td class="py-3">
                    {{ $t("searchResult.table.head.image") }}
                  </td>
                  <td>{{ $t("searchResult.table.head.form") }}</td>
                  <td>{{ $t("searchResult.table.head.size") }}</td>
                  <td>{{ $t("searchResult.table.head.color") }}</td>
                  <td>{{ $t("searchResult.table.head.clarity") }}</td>
                  <td>{{ $t("searchResult.table.head.cut") }}</td>
                  <td>{{ $t("searchResult.table.head.polish") }}</td>
                  <td>{{ $t("searchResult.table.head.symmetry") }}</td>
                  <td>{{ $t("searchResult.table.head.fluorescence") }}</td>
                  <td>{{ $t("searchResult.table.head.institute") }}</td>
                  <td>{{ $t("searchResult.table.head.price") }}</td>
                  <td>{{ $t("searchResult.table.head.details") }}</td>
                </tr>
              </tfoot>
              <tbody class="divide-y divide-brand-bg">
                <search-result-table-line
                  v-for="(diamond, diamondIdx) in pageResult"
                  :key="'diamond' + diamondIdx"
                  :diamond="diamond"
                />
              </tbody>
            </table>
          </div>
        </section>
        <div v-else class="col-span-2 bg-white">
          <div
            class="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center bg-white"
          >
            <svg
              class="mx-auto h-12 w-12 text-brand-main"
              xmlns="http://www.w3.org/2000/svg"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span class="mt-2 block text-sm font-medium text-gray-900">
              {{ $t("searchResult.body.empty") }}
            </span>
          </div>
        </div>

        <div
          class="w-full mt-10 text-center"
          v-if="
            searchResult.page &&
            searchResult.page.current < searchResult.page.last
          "
        >
          <button
            @click="showMore"
            type="button"
            class="mx-auto inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-brand-main hover:bg-brand-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-light"
          >
            <!-- Heroicon name: solid/plus-sm -->
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import SearchResultDiamond from "@/components/search/result/diamond";
import SearchResultTableLine from "@/components/search/result/tableLine";
import { useStore } from "vuex";

export default {
  name: "SearchResult",
  props: ["searchResult", "confSession"],
  components: {
    SearchResultTableLine,
    SearchResultDiamond,
  },
  setup(props) {
    const curRoute = useRoute();

    /**
     * Read current sort order from query
     * @returns {string}
     */
    const getSort = () => {
      if (curRoute.query.b === "size") {
        return curRoute.query.s === "desc" ? "caratDESC" : "caratASC";
      } else {
        return curRoute.query.s === "desc" ? "priceDESC" : "priceASC";
      }
    };

    const store = useStore();
    const itemSteps = 8;
    const itemsOnPage = ref(itemSteps);
    const currentPage = ref(
      props.searchResult.page ? props.searchResult.page.current : 1
    );
    const sortByType = ref(getSort());
    const viewType = ref("gallery");

    const showMore = () => {
      store.dispatch(
        "searchParameter/setPage",
        props.searchResult.page.current + 1
      );
      itemsOnPage.value = props.searchResult.page.current + 1;
    };

    const setSortBy = (sortBy) => {
      sortByType.value = sortBy;
      store.dispatch("searchParameter/setSortBy", sortBy);
    };

    const pageResult = computed(() => {
      let pageItems = [];
      if (
        props.searchResult.diamonds &&
        props.searchResult.diamonds.length > 0
      ) {
        pageItems = props.searchResult.diamonds;
      }

      return pageItems;
    });

    /**
     * Fast delivery
     */

    const fastDelivery = ref(curRoute.query.fd === "yes" || false);

    const toggleFastDelivery = (fastDeliveryStatus) => {
      fastDelivery.value = fastDeliveryStatus;
      store.commit("searchParameter/toggleValue", {
        name: "fastDelivery",
        value: fastDelivery.value,
      });
    };

    return {
      showMore,
      setSortBy,
      pageResult,
      itemsOnPage,
      currentPage,
      sortByType,
      viewType,
      fastDelivery,
      toggleFastDelivery,
    };
  },
};
</script>

<style></style>